import React, {
  Component
} from 'react';
// import Immutable from 'immutable';
import clsx from 'clsx';
import {
  withRouter
} from 'react-router-dom'
import getRemainingTime from 'helpers/getRemainingTime'
import RegistrationTwoStepsForm from 'components/Registration/RegistrationTwoStepsForm';
// import Immutable from 'immutable';
import {
  withStyles
} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// import { connect } from 'react-redux';
import config from 'config/api'
import Grid from '@material-ui/core/Grid';
// import withWidth from '@material-ui/core/withWidth';
// import isArray from 'mout/lang/isArray';
import IconPlay from '@material-ui/icons/PlayCircleFilled';
// import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
// import EventIntro from 'components/Event/EventIntro';
// import BlockTitle  from 'components/UI/BlockTitle';
// import BlockButton  from 'components/UI/BlockButton';
// import MyEventsContainer from 'components/Event/MyEventsContainer';
import RemainingTime from 'components/UI/RemainingTime';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
// import Spinner from 'components/UI/Spinner';
// import Header from '../Header/Header';
// import Footer from '../Footer';
// import LiveHelp from './LiveHelp';
// import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
// import Bubble from 'components/UI/Bubble';
// import HelpSpeedTest from 'components/Help/HelpSpeedTest';
import PopinWrapper from 'components/PopinWrapper';
import EventSubscription from 'components/Event/EventSubscription';
import EventSubscriptionFor from 'components/Event/EventSubscriptionFor';
import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';
// import { Redirect } from 'react-router-dom'
// import { withRouter } from 'react-router-dom'
import {
  primaryColor
} from 'helpers/colors';
import getCardImage from 'helpers/getCardImage';
import gotoLiveRoom from 'helpers/gotoLiveRoom'
const styles = (theme) => {
  // console.log(theme)
  return {
    cardRoot: {
      padding: '0 20px 40px',
      // marginBottom: '30px',
      margin: '0 auto 30px',
      maxWidth: 1280,
      // background: 'linear-gradient(278.43deg, #FFCCE7 0%, #30003B 80%)',
      borderBottom: '1px '+theme.palette.primary.main+' solid',
      '& .MuiTypography-h6': {
        marginTop: theme.spacing(2),
        color: theme.palette.primary.main
      }
    },
    h2: {
      // fontSize: '120%',
      fontSize: '32px',
      fontWeight: 'bold'
    },
    embed: {
      maxWidth: 'initial',
      padding: '30px 40px 20px',
      margin: '0 auto',
      borderBottom: '1px '+theme.palette.primary.main+' solid'
    },
    cardImage: {
      position: 'absolute',
      backgroundSize: 'contain',
      top: 30,
      right: 30,
      borderRadius: 90,
      width: 130,
      height: 130,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      border: '1px #ccc solid',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        top: 'initial',
        right: 'initial',
        margin: '0 auto 40px'
      }
    },
    cartTitle: {
      fontSize: '33px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '24px',
        marginBottom: '20px'
      }
    },
    cardtDescripion: {
      fontSize: '15px',
      [theme.breakpoints.down('sm')]: {
        // fontSize: '15px',
        marginBottom: '20px'
      }
    },
    cardContent: {
      width: '80%',
      margin: '40px 0',
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    cardContentEmbed: {
      margin: '40px 0 0'
    },
    cardTimeRemaininTitle: {
      // color: primaryColor,
      fontSize: '30px',
      marginBottom: 20
    },
    cardTimeRemaininText: {
      fontWeight: 'bold',
      // color: primaryColor,
      fontSize: '32px',
    },
    cardButton: {
      fontSize: '20px',
      padding: '8px 20px',
      backgroundColor: '#fff',
      margin: '0 auto 20px',
      display: 'flex',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.text.contrastText,
      fontWeight: 'bold',
      letterSpacing: '0.92px',
      // backgroundImage: 'none',
      '&:hover': {
        color: '#fff',
        // backgroundColor: primaryColor,
        // backgroundImage: 'none'
      }
    },
    cardTimeRemainin: {
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {}
    },
    remainintTime: {
      fontSize: '30px',
      marginBottom: 20,
      [theme.breakpoints.down('sm')]: {
        fontSize: '18px',
        marginBottom: 10,
      }
    }
  }
}
class EventCardBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timeRemaining: undefined,
      // remainingTime: 0,
      // remainingTimeDays: 0,
      // remainingTimeHours: 0,
      // remainingTimeMinutes: 0
    }
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  }
  componentDidMount() {
    if(this.props.showRemainingTime === true) this._startTimer();
  }
  componentDidUpdate(oldProps, oldState) {
    if(this.props.showRemainingTime === true && oldProps.$$data === undefined && this.props.data !== undefined) {
      this._startTimer();
    }
    if(oldState.showLiveButton !== true && this.state.showLiveButton === true) {
      const {
        $$card,
        $$subscriptions
      } = this.props;
      // console.log($$card.get('eventState'), $$subscriptions.toJS())
      if(this.props.$$subscriptions.contains(this.props.$$card.get('id'))) this.props.onLiveStarted()
    }
  }
  componentWillUnmount() {
    this._stopTimer();
  }
  _stopTimer() {
    // console.log('stopping')
    if(this._remainingTimer) clearInterval(this._remainingTimer);
  }
  _startTimer() {
    // const $$card = this._getCard();
    const {
      $$card
    } = this.props;
    // console.log('timer 1')
    if($$card === undefined) return;
    // console.log('timer 2')
    this._cardTimer = $$card.get('eventDate');
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }
  _runRemainingTimer() {
    const {
      $$card
    } = this.props;
    // console.log('run1')
    if($$card === undefined) return;
    // console.log('run2')
    // $$card.get('eventDate')
    const timeRemaining = $$card !== undefined ? getRemainingTime($$card.get('eventDate')) : {};
    // console.log(timeRemaining)
    // console.log($$card.toJS())
    if((timeRemaining.days <= 0 && timeRemaining.hours <= 0 && timeRemaining.minutes <= this.props.delay) || $$card.get('eventState') === 'live') {
      this.setState({
        showLiveButton: true
      }, () => {
        // console.log('STOPPPING')
        this._stopTimer();
      })
    } else {
      const {
        showLiveButton
      } = this.state
      // console.log('RUN')
      this.setState({
        timeRemaining
      });
    }
    //
    //   // var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
    //   var countDownDate = this._cardTimer;
    //   // console.log('countDownDate', countDownDate)
    //   if (!countDownDate)
    //     return;
    //   var now = new Date().getTime();
    //   var distance = (countDownDate * 1000) - now;
    //
    //   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    //   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    //   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    //   // var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    //
    //   const tStr = days + " Jour" + (
    //     days > 1
    //     ? 's'
    //     : '') + " " + hours + " Heure" + (
    //     hours > 1
    //     ? 's'
    //     : '') + " " + minutes + " Minute" + (
    //     minutes > 1
    //     ? 's'
    //     : '') + "";
    //   this.setState({remainingTime: tStr, remainingTimeDays: days, remainingTimeHours: hours, remainingTimeMinutes: minutes})
    //   if (distance < 0) {
    //     clearInterval(this._remainingTimer);
    //     // this.setState({showPlayButton: true})
    //   }
  }
  _gotoLiveRoom(e) {
    e.preventDefault();
    // const $$card = this._getCard();
    const {
      $$card,
      history
    } = this.props;
    // console.log('click', $$card.toJS())
    // window.open($$card.get('eventLinkExternal'))
    // gotoLiveRoom($$card, (res) => {
      // if(res === true)
      history.push('/live/' + $$card.get('id'));
    // })
  }
  _getCard() {
    const {
      $$data
    } = this.props;
    return $$data !== undefined && $$data.get('live') !== undefined && $$data.get('live').size > 0 ? $$data.get('live').get(0) : undefined
  }
  render() {
    const {
      // $$data,
      userRole,
      // onPanelToggle,
      classes,
      $$card,
      style,
      $$subscriptions,
      onSubscriptionComplete,
      showRemainingTime,
      embed,
      $$user,
      showDescription,
      remainingTimeOnly,
    } = this.props;
    // console.log($$card)
    const cardImage = getCardImage($$card);
    // console.log({cardImage})
    // console.log({showRemainingTime})
    const {
      timeRemaining,
      showLiveButton
    } = this.state;
    // console.log({showLiveButton})
    return (<React.Fragment>
      <Box py={2} px={2} className={clsx(classes.cardRoot, {
          [classes.embed]: embed
      })} style={style}>
        <If condition={showRemainingTime !== false && timeRemaining !== undefined && showLiveButton !== true && (timeRemaining.days >= 0 && timeRemaining.hours >= 0 && timeRemaining.minutes >= 0)}>

          <Grid item={true} xs={12}>
            <div className={classes.cardTimeRemainin}>
              <Typography variant="h5" gutterBottom={true}>Votre prochaine conférence débute dans :</Typography>
              <RemainingTime days={timeRemaining.days} hours={timeRemaining.hours} minutes={timeRemaining.minutes} className={classes.remainintTime} variant={'h4'} />
              <If condition={showLiveButton !== true}>
                  <Typography variant="h6"><span className={classes.inline}>Vous verrez apparaître ici un bouton "accéder au live"&nbsp;</span><span className={classes.inline}>{this.props.delay} minutes avant le début de votre émission</span></Typography>
              </If>
            </div>
          </Grid>
        </If>
        <If condition={showRemainingTime !== false && showLiveButton === true}>
          <Box mb={3} maxWidth="80%" ml={'10%'}>
            <Typography variant="h5" color="primary" align="center" gutterBottom={true}>Actuellement live :</Typography>
            <Typography variant="h5" align="center" gutterBottom={true} component="div"><Paragrapher text={$$card.get('eventTitle')} prettyfy={true}/></Typography>
          </Box>
        </If>
        <If condition={remainingTimeOnly !== true}>
          <Choose>
          <When condition={userRole !== undefined && userRole !== 'visitor' && $$card.get('eventState') !== 'replay' && (userRole !== 'member' || (userRole === 'member' && $$subscriptions.contains($$card.get('id')))) && showLiveButton === true }>
            <Button size="large" className={classes.cardButton} variant="contained" color="primary" onClick={this._gotoLiveRoom}>
              <span>Accéder au live</span>
            </Button>
          </When>
          <Otherwise>
            <If condition={userRole !== 'staff' && $$card.get('eventState') === 'live'}>
            <Typography variant="h5" align="center" gutterBottom={true}>Veuillez vous inscrire ci-dessous pour participer à cette webconférence !</Typography>
          </If>
          </Otherwise>
          </Choose>
          <If condition={userRole === undefined || userRole === 'visitor'}>

            <DialogPopinButton trigger={PopinWrapper} triggerProps={{
                className: classes.cardButton,
                label: "S'inscrire",
                endIcon: <AddIcon/>,
              size: 'large',
              icon: false,
              button: true
            }} popinTitle={false} popinTitleStyle={{
              paddingBottom: 0,
              height: 1
            }} popinContent={RegistrationTwoStepsForm} popinContentProps={{
              onFormComplete: onSubscriptionComplete,
              onRegistrationShow: onSubscriptionComplete,
              $$event: $$card,
              $$user: $$user,
              showRecap: true,
              closeOnComplete: true,
              // $$events: $$events,
              userRole
            }} openOnMount={false} onClosed={onSubscriptionComplete}/>


          </If>
          {/*      <If condition={userRole === 'member' && !$$subscriptions.contains($$card.get('id'))}>
          <DialogPopinButton trigger={PopinWrapper} triggerProps={{
          className: classes.cardButton,
          label: "S'inscrire",
          endIcon: <AddIcon/>,
          size: 'large',
          icon: false,
          button: true
          }} popinTitle={false} popinTitleStyle={{
          paddingBottom: 0,
          height: 1
          }} popinContent={EventSubscription} popinContentProps={{
          $$event: $$card,
          $$user: $$user,
          userRole
          }} openOnMount={false} onClosed={onSubscriptionComplete}/>
          </If>*/}
          {/*<If condition={userRole === 'staff' || userRole === 'admin'}>
            <DialogPopinButton trigger={PopinWrapper} triggerProps={{
                className: classes.cardButton,
                label: "Inscrire",
                endIcon: <AddIcon/>,
              size: 'large',
              icon: false,
              button: true
            }} popinTitle={<span> Inscription à une conférence</span>} popinContent={EventSubscriptionFor} popinContentProps={{
              $$event: $$card,
              userRole
            }} openOnMount={false} onClosed={onSubscriptionComplete}/>
          </If>*/}
        </If>
      </Box>

    </React.Fragment>);
  }
}
// export default ;
export default withRouter(withStyles(styles)(EventCardBanner));



// WEBPACK FOOTER //
// ./src/components/Event/EventCardBanner.jsx